import { supabase } from '../lib/supabase';

class EmailNotificationService {
  /**
   * Send match notification email
   */
  async sendMatchEmail({ recipientEmail, recipientName, matchDetails, userRole }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-match-email', {
        body: {
          recipientEmail,
          recipientName,
          matchDetails,
          userRole
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending match email:', error);
      return { success: false, error: error?.message };
    }
  }

  /**
   * Send message notification email
   */
  async sendMessageEmail({ recipientEmail, recipientName, senderName, messagePreview, conversationUrl }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-message-email', {
        body: {
          recipientEmail,
          recipientName,
          senderName,
          messagePreview,
          conversationUrl
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending message email:', error);
      return { success: false, error: error?.message };
    }
  }

  /**
   * Send interview reminder email
   */
  async sendInterviewReminder({ recipientEmail, recipientName, interviewDetails, reminderType }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-interview-reminder', {
        body: {
          recipientEmail,
          recipientName,
          interviewDetails,
          reminderType
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending interview reminder:', error);
      return { success: false, error: error?.message };
    }
  }

  /**
   * Send profile approval notification to admin
   */
  async sendApprovalNotification({ adminEmail, adminName, requestDetails, notificationType }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-approval-notification', {
        body: {
          adminEmail,
          adminName,
          requestDetails,
          notificationType
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending approval notification:', error);
      return { success: false, error: error?.message };
    }
  }

  /**
   * Schedule interview reminders based on user preferences
   */
  async scheduleInterviewReminders(interview, userPreferences) {
    const scheduledAt = new Date(interview.scheduled_at);
    const now = new Date();
    const timeDiff = scheduledAt - now;

    // Get reminder preferences (default to 24 hours)
    const reminderTiming = userPreferences?.interview_reminder_timing || '24hours';
    
    const reminderOffsets = {
      '1hour': 60 * 60 * 1000, // 1 hour in ms
      '24hours': 24 * 60 * 60 * 1000, // 24 hours in ms
      '48hours': 48 * 60 * 60 * 1000, // 48 hours in ms
      'week': 7 * 24 * 60 * 60 * 1000 // 1 week in ms
    };

    const reminderOffset = reminderOffsets?.[reminderTiming] || reminderOffsets?.['24hours'];

    // Check if we should send reminder now
    if (timeDiff > 0 && timeDiff <= reminderOffset) {
      return true; // Trigger reminder
    }

    return false;
  }
}

export const emailNotificationService = new EmailNotificationService();